(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["frame-addons"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-frame-addons]').forEach(initFrameAddons);
  });

  function formatMoney(cents, currency) {
    return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: currency });
  }

  function getSelectedAddons(wrapper) {
    const items = [];
    wrapper.querySelectorAll('.addon-checkbox:checked').forEach((cb) => {
      items.push({
        id: parseInt(cb.dataset.variantId, 10),
        quantity: 1,
        priceCents: parseInt(cb.dataset.price, 10),
        properties: { '_Pour le produit': wrapper.dataset.productTitle },
      });
    });
    return items;
  }

  async function addAllToCart(wrapper, mainVariantId, button, originalLabel) {
    button.disabled = true;
    button.textContent = 'Ajout en cours...';

    const { CartAddEvent } = await import('@theme/events');

    const items = [{ id: mainVariantId, quantity: 1 }].concat(
      getSelectedAddons(wrapper).map((a) => ({ id: a.id, quantity: a.quantity, properties: a.properties }))
    );

    const cartItemsComponents = document.querySelectorAll('cart-items-component');
    const sectionIds = [];
    cartItemsComponents.forEach((el) => {
      if (el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
    });

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: sectionIds.join(',') }),
      });

      const data = await res.json();

      if (!res.ok) {
        console.error('Détail erreur Shopify:', data);
        throw new Error(data.description || 'Erreur ajout panier');
      }

      document.dispatchEvent(
        new CartAddEvent({}, mainVariantId.toString(), {
          source: 'product-form-component',
          itemCount: items.reduce((sum, i) => sum + i.quantity, 0),
          sections: data.sections,
        })
      );

      const drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      } else {
        window.location.href = '/cart';
      }

      button.disabled = false;
      button.textContent = originalLabel;
    } catch (err) {
      console.error(err);
      button.textContent = 'Erreur, réessaie';
      button.disabled = false;
      setTimeout(() => {
        button.textContent = originalLabel;
      }, 2000);
    }
  }

  let currentLightboxImages = [];
  let currentLightboxIndex = 0;

  function openAddonLightbox(images, startIndex) {
    if (!images.length) return;
    currentLightboxImages = images;
    currentLightboxIndex = startIndex;

    const overlay = document.createElement('div');
    overlay.className = 'addon-lightbox';
    overlay.innerHTML = `
    <button class="addon-lightbox__close" aria-label="Fermer">&times;</button>
    ${
      images.length > 1
        ? '<button class="addon-lightbox__nav addon-lightbox__nav--prev" aria-label="Précédent">&#8249;</button>'
        : ''
    }
    <div class="addon-lightbox__image-wrap">
      <img src="${images[startIndex].url}" alt="${images[startIndex].alt}">
    </div>
    ${
      images.length > 1
        ? '<button class="addon-lightbox__nav addon-lightbox__nav--next" aria-label="Suivant">&#8250;</button>'
        : ''
    }
    ${images.length > 1 ? `<div class="addon-lightbox__counter">${startIndex + 1} / ${images.length}</div>` : ''}
  `;

    document.body.appendChild(overlay);

    const imgEl = overlay.querySelector('img');
    const counterEl = overlay.querySelector('.addon-lightbox__counter');

    function updateImage() {
      imgEl.src = currentLightboxImages[currentLightboxIndex].url;
      imgEl.alt = currentLightboxImages[currentLightboxIndex].alt;
      if (counterEl) counterEl.textContent = `${currentLightboxIndex + 1} / ${currentLightboxImages.length}`;
    }

    overlay.querySelector('.addon-lightbox__close').addEventListener('click', () => overlay.remove());
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) overlay.remove();
    });

    const prevBtn = overlay.querySelector('.addon-lightbox__nav--prev');
    const nextBtn = overlay.querySelector('.addon-lightbox__nav--next');

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        currentLightboxIndex = (currentLightboxIndex - 1 + currentLightboxImages.length) % currentLightboxImages.length;
        updateImage();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        currentLightboxIndex = (currentLightboxIndex + 1) % currentLightboxImages.length;
        updateImage();
      });
    }

    function handleKeydown(e) {
      if (e.key === 'Escape') overlay.remove();
      if (e.key === 'ArrowLeft' && prevBtn) prevBtn.click();
      if (e.key === 'ArrowRight' && nextBtn) nextBtn.click();
    }
    document.addEventListener('keydown', handleKeydown);

    const observer = new MutationObserver(() => {
      if (!document.body.contains(overlay)) {
        document.removeEventListener('keydown', handleKeydown);
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true });
  }

  function initAddonLightboxes(wrapper) {
    wrapper.querySelectorAll('.addon-thumb').forEach((thumb) => {
      thumb.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const targetId = this.dataset.imagesTarget;
        const scriptEl = document.getElementById(targetId);
        if (!scriptEl) return;

        let images = [];
        try {
          images = JSON.parse(scriptEl.textContent);
        } catch (err) {
          console.error('Impossible de lire les images du produit', err);
          return;
        }

        openAddonLightbox(images, 0);
      });
    });
  }

  async function initFrameAddons(wrapper) {
    let basePriceCents = parseInt(wrapper.dataset.basePrice, 10);
    const currency = wrapper.dataset.currency;

    const form = document.querySelector('product-form-component form[data-type="add-to-cart-form"]');
    const nativeBtn = form ? form.querySelector('[ref="addToCartButton"]') : null;
    const variantInput = form ? form.querySelector('input[name="id"]') : null;

    function getPriceEl() {
      return document.querySelector('product-price [ref="priceContainer"] .price');
    }

    function updateDisplayedPrice() {
      let total = basePriceCents;
      getSelectedAddons(wrapper).forEach((a) => {
        total += a.priceCents;
      });
      return total;
    }

    function refreshPrice() {
      const priceEl = getPriceEl();
      if (priceEl) {
        priceEl.textContent = formatMoney(updateDisplayedPrice(), currency);
      }
    }

    initAddonLightboxes(wrapper);

    wrapper.querySelectorAll('.addon-checkbox').forEach((cb) => {
      cb.addEventListener('change', refreshPrice);
    });

    wrapper.querySelectorAll('.addon-variant-select').forEach((select) => {
      select.addEventListener('click', (e) => e.stopPropagation());
      select.addEventListener('change', function () {
        const item = this.closest('.addon-item');
        const checkbox = item.querySelector('.addon-checkbox');
        const priceDisplay = item.querySelector('[data-addon-price-display]');
        const selectedOption = this.options[this.selectedIndex];
        const normalPriceCents = parseInt(selectedOption.dataset.price, 10);
        const kitPriceRaw = selectedOption.dataset.kitPrice;
        const hasKitPrice = kitPriceRaw && kitPriceRaw !== '';
        const effectivePriceCents = hasKitPrice ? parseInt(kitPriceRaw, 10) : normalPriceCents;

        checkbox.dataset.variantId = selectedOption.value;
        checkbox.dataset.price = effectivePriceCents;

        if (priceDisplay) {
          if (hasKitPrice) {
            priceDisplay.classList.add('addon-price--promo');
            priceDisplay.innerHTML = `
          <span class="addon-price-old">${formatMoney(normalPriceCents, currency)}</span>
          <span class="addon-price-new">${formatMoney(effectivePriceCents, currency)}</span>
        `;
          } else {
            priceDisplay.classList.remove('addon-price--promo');
            priceDisplay.textContent = formatMoney(normalPriceCents, currency);
          }
        }

        refreshPrice();
      });
    });

    if (nativeBtn) {
      nativeBtn.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          const currentVariantId = variantInput
            ? parseInt(variantInput.value, 10)
            : parseInt(wrapper.dataset.mainVariantId, 10);
          addAllToCart(wrapper, currentVariantId, nativeBtn, nativeBtn.textContent);
        },
        true
      );
    }

    const { ThemeEvents } = await import('@theme/events');

    const sectionContainer = document.querySelector('product-information') || document.body;

    const priceObserver = new MutationObserver(() => {
      const priceEl = getPriceEl();
      if (!priceEl) return;

      const expected = formatMoney(updateDisplayedPrice(), currency);
      if (priceEl.textContent.trim() !== expected.trim()) {
        priceEl.textContent = expected;
      }
    });

    priceObserver.observe(sectionContainer, { characterData: true, childList: true, subtree: true });

    document.addEventListener(ThemeEvents.variantUpdate, function (event) {
      if (event.detail && event.detail.resource && typeof event.detail.resource.price === 'number') {
        basePriceCents = event.detail.resource.price;
      }
      // Le changement de variante peut ne pas déclencher de mutation détectable immédiatement,
      // on force un recalcul après un court délai pour être sûr
      setTimeout(refreshPrice, 100);
    });
  }
  } catch(e) { console.error(e); }
})();

})();
